// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin:0}*{box-sizing:border-box}ul{margin:0;padding:0}li{list-style:none}.el-pagination .btn-next .el-icon,.el-pagination .btn-prev .el-icon{display:inline-block!important}.fenye{margin:15px 0 0;text-align:right}", ""]);
// Exports
module.exports = exports;
